import { Entity } from '@adornis/baseql/decorators.js';
import { Counter } from '@adornis/counter/counter.js';
import { DateTime } from 'luxon';
import { BHOrderNr } from '../../entities/BHPayment.js';

@Entity()
export class BHDemoOrderNr extends BHOrderNr {
  static override _class = 'BHDemoOrderNr';

  static override async create(institutionID: string) {
    const year = DateTime.now().year;
    const nr = await Counter.getIncrementingNumber(institutionID + '::orderCounter::' + year)();
    return new BHDemoOrderNr({ year, nr });
  }

  override getOrderNr() {
    const padNr = this.nr.toString().padStart(4, '0');
    return `05/${this.year}/HDW/${padNr}`;
  }
}
